import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import './styles/global.css';
import { installAxiosAuthInterceptor } from './config/axiosAuth';
import { installRefreshOn401, SESSION_EXPIRED_EVENT } from './services/authRefreshInterceptor';
import { installVisibilityRefresh, onTokenChange, restoreSession } from './services/tokenStore';
import { getCurrentUser, logout, tokenChanged } from './store/slices/authSlice';

installAxiosAuthInterceptor();
installRefreshOn401();
installVisibilityRefresh();

// Keep the Redux copy of the token in step with the in-memory one (refreshes happen outside React).
// Deferred a tick so a token change made while a reducer runs can never dispatch from inside it.
onTokenChange((token) => queueMicrotask(() => store.dispatch(tokenChanged(token))));
window.addEventListener(SESSION_EXPIRED_EVENT, () => {
  store.dispatch(logout());
});

async function start() {
  // The access token is memory-only, so a reload starts without one. Get it back from the httpOnly
  // refresh cookie before the first screen, so protected routes do not flash the login page.
  const token = await restoreSession();
  if (token) await store.dispatch(getCurrentUser());

  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <Provider store={store}>
        <App />
      </Provider>
    );
  }
}

void start();
